<template>
  <div class="soon_fu">
    <p class="jjmb">即将满班课程展示</p>


    <swiper :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback" style="padding-left:2rem;">
      <!--1-->
      <swiper-slide  v-for="(item,index) in fullclasslist" :key="item.Id">
        <div class="jjbm" @click="hrefClick(item)">
          <div class="jjbm1">
            <p class="kcbt">{{item.FullName}}</p>
            <div class="kcsj">
              <i class="classTime"></i>
              <p class="classTime1">{{item.StartDate}}至{{item.EndDate}}</p>
            </div>
            <div class="kcsj a">
              <i class="classTime a"></i>
              <p class="classTime1">{{item.LearnPlace}}</p>
            </div>
            <p class="kc_jg">￥{{item.Price}}</p>
          </div>
        </div>
      </swiper-slide>

    </swiper>
  </div>
</template>
<script>
  //http://souke.xdf.cn/Class/1-3196064.html
  import 'swiper/dist/css/swiper.css'

  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  export default{
    props: ['fullclasslist', 'schoolid'],
    components: {
      swiper,
      swiperSlide
    },
    data: function () {
      return {
        swiperOption:{
          /*slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 20,*/
          scrollbarHide: true,
          slidesPerView: 'auto',
          centeredSlides: false,
          spaceBetween: 20,
          grabCursor: true
        }
      }
    },
    methods: {
      hrefClick(item){
        window.open(`http://souke.xdf.cn/Class/${this.schoolid}-${item.Id}.html`)
      },
      callback(){}
    },
    mounted(){
     /* window.setTimeout(function () {
        var swiper = new Swiper('#swiper-container2', {
          /!*scrollbar: '.swiper-scrollbar',*!/
          scrollbarHide: true,
          slidesPerView: 'auto',
          spaceBetween: 20,
          grabCursor: true
        });
      }, 1000)*/

    },

  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// components/FullClass.vue